import React, { useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import axios from 'axios';
import { uploadApplicationDocuments } from '../../../HttpRequest/uploadDocuments';

const Uploaddoc = ({ applicationId }) => {
// const applicationId="a309b1dc-debb-411a-be1f-6e284ede8af4";
// const userId="11101";
const fileList = [
  // {
  //   uid: '0',
  //   name: 'xxx.png',
  //   status: 'uploading',
  //   percent: 33,
  // },
  // {
  //   uid: '-1',
  //   name: 'yyy.png',
  //   status: 'done',
  //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  //   thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
  // },
  // {
  //   uid: '-2',
  //   name: 'zzz.png',
  //   status: 'error',
  // },
];

const handleFileChange = (e) => {
  setFile(e.target.files[0]);
};

const handleUpload = async ({ file, onSuccess, onError }) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    // Replace 'YOUR_UPLOAD_API_URL' with the actual API endpoint for file upload
    const response = uploadApplicationDocuments(applicationId, type, formData);

    console.log('File uploaded successfully:', response);
    if (response.ok) {
      onSuccess();
    } else {
      onError();
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    onError();
  }
};


  console.log("gettingapplication id-->",applicationId);
return(
  <>
    <Upload
      customRequest={handleUpload}
      //action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
      listType="picture"
      defaultFileList={[...fileList]}
    >
      <Button icon={<UploadOutlined />}>Upload</Button>
    </Upload>
    <br />
    <br />
    <Upload
      //action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
      listType="picture"
      defaultFileList={[...fileList]}
      className="upload-list-inline"
    >
      <Button icon={<UploadOutlined />}>Upload</Button>
    </Upload>
  </>
)};

export default Uploaddoc;